// src/pages/Users/Lexique/components/LexiqueHero.jsx

import React from "react";
import {
  FaBookOpen,
  FaHeart,
  FaLanguage,
  FaSearch,
} from "react-icons/fa";

export default function LexiqueHero({
  discipline,
  totalCount,
  filteredCount,
  favoritesCount,
  favOnly,
}) {
  return (
    <section className="relative overflow-hidden rounded-[2rem] bg-slate-950 p-5 text-white shadow-xl shadow-slate-950/10 sm:p-6">
      <div className="pointer-events-none absolute -right-16 -top-16 h-44 w-44 rounded-full bg-sky-500/25 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-48 w-48 rounded-full bg-orange-500/25 blur-3xl" />

      <div className="relative">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-sky-200">
          Vocabulaire · Prononciation · Favoris
        </p>

        <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-2xl font-bold tracking-tight sm:text-3xl">
              Lexique {discipline}
            </h2>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-200">
              Consulte rapidement les termes japonais, écoute la prononciation,
              copie une traduction et garde tes mots importants en favoris.
            </p>
          </div>

          <div className="grid grid-cols-4 gap-2 sm:min-w-[420px]">
            <HeroStat icon={FaBookOpen} label="Total" value={totalCount} />
            <HeroStat icon={FaSearch} label="Affichés" value={filteredCount} />
            <HeroStat icon={FaHeart} label={favOnly ? "Favoris" : "Mes fav."} value={favoritesCount} />
            <HeroStat icon={FaLanguage} label="Langue" value="JP" />
          </div>
        </div>
      </div>
    </section>
  );
}

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/10 p-2.5 text-center backdrop-blur sm:p-3">
      <div className="mx-auto flex h-8 w-8 items-center justify-center rounded-xl bg-white/15 sm:h-9 sm:w-9">
        <Icon className="text-sm text-white" />
      </div>

      <p className="mt-2 text-base font-bold leading-none sm:text-lg">
        {value}
      </p>

      <p className="mt-1 text-[10px] font-medium text-slate-300 sm:text-[11px]">
        {label}
      </p>
    </div>
  );
}